import './App.css'
import Router from './components/Router'
import Context from './components/Context'
function App() {

  const userInfo = {
    name: "Johnny",
    email: "test@gmail.com",
    loggedIn: true,
    cartItems: 2
  }
  return (
    <>
      <Context.Provider value={userInfo}>
        <Router />
      </Context.Provider>
    </>
  );
}

export default App;
